import React from 'react';
import { Link } from 'react-router-dom';

function SiteHeader() {
  return (
    <div>
        <Link to="/"><h1>Ainews</h1></Link>
    </div>
  )
}

export default SiteHeader